import React from 'react';
import suzuki from '../../../assets/bike-icon/suzuki.png'
import hero from '../../../assets/bike-icon/hero.png'
import runner from '../../../assets/bike-icon/runner.png'
import bajaj from '../../../assets/bike-icon/bajaj.png'
// import tvs from '../../../assets/bike-icon/tvs.png'
import Category from './Category';

const Categories = () => {

    const BikeData = [
        {
            id: 1,
            name: 'Suzuki',
            icon: suzuki,
            category: 'suzuki'
        },
        {
            id: 2,
            name: 'Hero',
            icon: hero,
            category: 'hero'
        },
        {
            id: 3,
            name: 'Runner',
            icon: runner,
            category: 'runner'
        },
        {
            id: 4,
            name: 'Bajaj',
            icon: bajaj,
            category: 'bajaj'
        },
    ]


    return (
        <div >
            <h1 className='text-3xl font-bold text-center mt-5 text-[#149777]'>Categories</h1>
            <div className='grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-3 mt-5 mb-10'>
                {
                    BikeData.map(category => <Category
                        key={category.id}
                        category={category}
                    ></Category>)
                }
            </div>
        </div>
    );
};

export default Categories;